import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v16h7v2h8v-2h7V3zm-2 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z"
}), 'AddToQueueSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AddToQueueSharp.js
// module id = 1924
// module chunks = 2